module.exports = __webpack_public_path__ + "b7ea0a52fc9a6756538d2efe7c187a71.pdf";